import { Map, useMap } from "@vis.gl/react-google-maps";
import Button from "../components/Button";

import { ReactComponent as IconArrow } from "../img/icons/arrow-right.svg";
import IconMire from "../img/icons/mire.png";

import useIncrementSimulationStep from "../hooks/useIncrementSimulationStep";

const LocationStep = () => {
  const {simParams, incrementSimulationStep} = useIncrementSimulationStep();
  const map = useMap();

  const setAdjustedLocation = () => {
    const center = map.getCenter();
    incrementSimulationStep({ ...simParams, adjustedLocation: { lat: center.lat(), lng: center.lng() }});
  }

  return (
    <>
      <div className="left">
        <img alt="" className="mire" src={IconMire}/>
        <Map
          zoom={20}
          tilt={0}
          mapTypeId={'satellite'}
          defaultCenter={simParams.location.location}
          gestureHandling={'greedy'}
          disableDefaultUI={true}>
        </Map>
      </div>
      <div className="right">
        <div className="text">
          <h2>Votre 🤩 localisation</h2>
          <span>Faites glisser la carte pour positionner le repère au centre de votre toiture, puis cliquez sur le bouton pour valider votre localisation.</span>
        </div>
        <Button 
          IconAfter={IconArrow} 
          link='/simulateur/orientation' 
          onclick={setAdjustedLocation}
        >Valider ma localisation</Button>
      </div>
    </>
  )
}

export default LocationStep;